export const CURRENT_USER_QUERY_KEY = ["currentUser"];

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface LoginResponse {
  success: boolean;
  token: string;
}

export interface RegisterCredentials {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
}

export interface RegisterResponse {
  token: string;
}

export interface VerifyEmailCredentials {
  token: string;
}

export interface VerifyEmailResponse {
  success: boolean;
}

export interface SendVerificationEmailResponse {
  success: boolean;
}

export interface ChangePasswordCredentials {
  currentPassword: string;
  newPassword: string;
}

export interface ChangePasswordResponse {
  success: boolean;
}

export interface ForgotPasswordCredentials {
  email: string;
}

export interface ForgotPasswordResponse {
  success: boolean;
}

export interface ResetPasswordCredentials {
  token: string;
  password: string;
}

export interface ResetPasswordResponse {
  success: boolean;
}

export interface AuthError {
  message: string;
  status?: number;
}

export interface LinkStravaCredentials {
  code: string;
}

export interface LinkStravaResponse {
  success: boolean;
}

export interface UnlinkStravaResponse {
  success: boolean;
}
